import styled from "styled-components";
import Table from "../DataTable";
import ListWithPagination from "../ListsWithPagination";
import { Colors } from "../../config/Constants";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  onOpenSendLinkModal: any;
  data: {
    name: string;
    contact: string;
    plate: string;
    car_type: string;
    car_brand: string;
    car_model: string;
    start_date: string;
    expiry_date: string;
    status: string;
  }[];
  isTableDataLoading: boolean;
  currentPage: number;
  totalData: number;
  onPageChange: (page: number) => void;
}

const DisputeHistoryTable = ({
  data,
  isTableDataLoading,
  onOpenSendLinkModal,
  currentPage,
  totalData,
  onPageChange,
}: Props) => {
  const getExpiryContent = (data: any) => {
    let [day, month, year] = data?.expiry_date?.split("/");
    let isoDate = new Date(`${year}-${month}-${day}`);

    const expiryDate = isoDate;
    const currentDate = new Date();
    if (data?.isActive === true) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div style={{ color: Colors.mainGreen }}>{data?.expiry_date}</div>
          <div>
            <div
              style={{
                width: "60px",
                background: Colors.mainGreen,
                padding: "4px",
                borderRadius: "32px",
                color: "white",
                textAlign: "center",
                fontSize: "12px",
                marginTop: "2px",
              }}
            >
              {data?.isRenewal ? "Active/Renewal" : "Active"}
            </div>
          </div>
        </div>
      );
    } else {
      if (expiryDate < currentDate) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div style={{ color: Colors.red }}>{data?.expiry_date}</div>
            <div>
              <div
                style={{
                  width: "60px",
                  background: Colors.red,
                  padding: "4px",
                  borderRadius: "32px",
                  color: "white",
                  textAlign: "center",
                  fontSize: "12px",
                  marginTop: "2px",
                }}
              >
                Expired
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div style={{ color: Colors.electricBlue }}>
              {data?.expiry_date}
            </div>
            <div>
              <div
                style={{
                  width: "60px",
                  background: Colors.electricBlue,
                  padding: "4px",
                  borderRadius: "32px",
                  color: "white",
                  textAlign: "center",
                  fontSize: "12px",
                  marginTop: "2px",
                }}
              >
                Pending
              </div>
            </div>
          </div>
        );
      }
    }
  };

  const columns = [
    {
      path: "name",
      label: "Name",
    },
    {
      path: "contact",
      label: "Contact",
    },
    {
      path: "plate",
      label: "Plate No.",
    },
    {
      path: "car_brand_model",
      label: "Car Brand & Model",
      content: (data: any) => (
        <div>
          {data?.car_brand || ""}-{data?.car_model || ""}
        </div>
      ),
    },
    {
      path: "car_type",
      label: "Car Type",
    },
    {
      path: "start_date",
      label: "Start Date",
    },
    {
      path: "expiry_date",
      label: "Expiry Date",
      content: (data: any) => getExpiryContent(data),
    },
    {
      path: "status",
      label: "Status",
    },
    {
      path: "paymentStatus",
      label: "Payment Status",
    },
    // {
    //   path: "edit",
    //   label: "Edit",
    //   content: (data: any) => (
    //     <img
    //       onClick={() =>
    //         data.isActive && data.paymentStatus === "Success"
    //           ? null
    //           : onOpenSendLinkModal(data)
    //       }
    //       style={{
    //         width: "24px",
    //         opacity: data.isActive && data.paymentStatus === "Success" ? 0.5 : 1,
    //         cursor: data.isActive && data.paymentStatus === "Success" ? 'not-allowed' : 'auto',
    //       }}
    //       src={require("../../assets/images/edit_amd.png")}
    //     />
    //   ),
    // },
  ];

  return (
    <>
      <TableWrapper>
        <TableWithPagination
          // showHighlight={true}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          currentPage={currentPage}
          totalData={totalData}
          rowsPerPage={5}
          onPageChange={onPageChange}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={""}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={onPageChange}
        />
      </ListWrapper>
    </>
  );
};
const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    padding-top: 4.5rem;
    display: none;
  }
`;
const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default DisputeHistoryTable;
